import { PhoneInput, ValidatingInput, ValidationForm, ValidationSummary } from '@ygtechnologies/bygr-frontend-component-library';
import React, { useState } from 'react';
import theme from './UsersTable.module.scss';
import { updateUser } from '@/services/users';
import { BygrUser } from '@/types';
import { AlertBanner, Button, ButtonBar, Dialog } from '@ygtechnologies/rubus-ui';
const EditUserModal: React.FC<{ isOpen: boolean; user: BygrUser; toggle: () => void; onSave: () => void }> = ({
    isOpen,
    user,
    toggle,
    onSave,
}) => {
    const [email, setEmail] = useState(user.email);
    const [phoneNumber, setPhoneNumber] = useState(user.phoneNumber);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const handleSave = async () => {
        setIsLoading(true);
        const res = await updateUser({ ...user, email, phoneNumber });
        setIsLoading(false);
        if (res.ok) {
            onSave();
            toggle();
        } else {
            setErrorMessage(res.errorMessage);
        }
    };

    const handleOpen = () => {
        setEmail(user.email);
        setPhoneNumber(user.phoneNumber);
    };
    return (
        <Dialog open={isOpen} onOpenChange={(open) => !open && toggle()} onOpen={handleOpen}>
            <Dialog.Content contentWidth="sm">
                <Dialog.Header>Edit "{user.displayName}"</Dialog.Header>
                <AlertBanner type="info">
                    <b>Be careful</b> when editing phone numbers or email addresses. Make sure the information allways is
                    connected to the same user. This feature should <b>never</b> be used to{' '}
                    <b>move a user form one person to another.</b>
                </AlertBanner>
                {!phoneNumberHasCountryCode(phoneNumber) && (
                    <AlertBanner type="danger">
                        <b>Phone number</b> does not start with a <b>country code</b>. To fix this, remove the last number
                        and add it again.
                    </AlertBanner>
                )}
                <ValidationForm onSubmit={handleSave} className="form columns-1">
                    <label>
                        Email
                        <ValidatingInput
                            required
                            type="email"
                            autoComplete="off"
                            className="form-control"
                            placeholder={'Email'}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </label>
                    <label>
                        Phone number
                        <br />
                        <PhoneInput
                            fieldName="Phone number"
                            required
                            className="form-control"
                            value={phoneNumber || ''}
                            onChange={(e) => setPhoneNumber(e)}
                        />
                    </label>

                    <div className="label-offset">
                        <ValidationSummary />
                        <div className={theme.error}>{errorMessage}</div>
                    </div>

                    <ButtonBar>
                        <ButtonBar.Right>
                            <Button variant="tertiary" onClick={toggle}>
                                Cancel
                            </Button>
                            <Button type="submit" variant="primary" loading={isLoading}>
                                Update
                            </Button>
                        </ButtonBar.Right>
                    </ButtonBar>
                </ValidationForm>
            </Dialog.Content>
        </Dialog>
    );
};

const phoneNumberHasCountryCode = (phoneNumber: string | null) => {
    if (!phoneNumber) return false;
    return phoneNumber.startsWith('+');
};

export default EditUserModal;
